module.exports = __webpack_public_path__ + "static/media/door@2x.5f0f0a85.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/door@2x.png
// module id = 642
// module chunks = 0